<template>
    <kgr-multi-select
        :options="filteredOptions"
        :inline="inline"
        :value="value"
        searchable
        @post-input="updateWeekdays($event)"
    />
</template>

<script>
import MultiSelect from './MultiSelect';

export default {
    components: {
        'kgr-multi-select': MultiSelect
    },
    props: {
        value: {
            type: Array,
            required: false,
            default: () => []
        },
        inline: {
            type: Boolean,
            required: false,
            default: true
        },
    },
    data() {
        return {
            fullOptions: [
                {label: this.$t('weekday_1'), value: 1},
                {label: this.$t('weekday_2'), value: 2},
                {label: this.$t('weekday_3'), value: 3},
                {label: this.$t('weekday_4'), value: 4},
                {label: this.$t('weekday_5'), value: 5},
                {label: this.$t('weekday_6'), value: 6},
                {label: this.$t('weekday_7'), value: 7},
            ],
        }
    },
    computed: {
        filteredOptions() {
            let options = Array.from(this.fullOptions);
            this.value.forEach(element => {
                options = options.filter(option => {
                    return element.value !== option.value;
                })
            });
            return options;
        },
    },
    methods: {
        updateWeekdays(value) {
            const selection = '' === value ? null : value
            this.$emit('input', selection);
            this.$nextTick(() => {
                this.$emit('post-input', selection);
            });
        },
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
